import { aliases, mdi } from "vuetify/iconsets/mdi-svg";
import {
    mdiAccount,
    mdiLogout,
    mdiRefresh,
    mdiLink,
    mdiBrightness2,
    mdiUpload,
    mdiContentSave,
    mdiBookMultiple,
    mdiBook,
    mdiCalendarAccount,
    mdiCalendarBlank,
    mdiHospitalBuilding,
    mdiMicrosoftExcel,
    mdiEye,
    mdiEyeOff,
    mdiDelete,
    mdiMinus,
    mdiMenu,
    mdiMenuOpen,
    mdiAccountCircle,
    mdiGestureTap,
    mdiKeyboardBackspace,
    mdiEmailOutline,
    mdiCheck,
    mdiContentCopy,
    mdiHelp,
    mdiHelpBoxOutline,
    mdiHelpCircleOutline,
    mdiClose,
    mdiInfinity,
} from "@mdi/js";
const icons = {
    defaultSet: "mdi",
    aliases: {
        ...aliases,
        mdiLogout,
        mdiRefresh,
        mdiDelete,
        mdiMinus,
        mdiLink,
        mdiBrightness2,
        mdiUpload,
        mdiContentSave,
        mdiAccount,
        mdiBook,
        mdiBookMultiple,
        mdiAccountCircle,
        mdiCalendarAccount,
        mdiCalendarBlank,
        mdiHospitalBuilding,
        mdiMicrosoftExcel,
        mdiEye,
        mdiEyeOff,
        mdiMenu,
        mdiMenuOpen,
        mdiGestureTap,
        mdiKeyboardBackspace,
        mdiEmailOutline,
        mdiCheck,
        mdiContentCopy,
        mdiHelp,
        mdiHelpBoxOutline,
        mdiHelpCircleOutline,
        mdiClose,
        mdiInfinity,
    },
    sets: {
        mdi,
    },
};
export default icons;
